import styled from 'styled-components';

const Styled = styled.div`
    .ant-card {
        .ant-card-cover {
            img {
                max-width: 100px;
                padding: 12px;
                margin: 0 auto;
            }
        }

        .ant-card-body {
            .ant-card-meta {
                .ant-card-meta-detail {
                    .ant-card-meta-title,
                    .ant-card-meta-description {
                        text-align: center;
                    }
                }
            }
        }
    }
`;
export default Styled;
